export default __webpack_public_path__ + "aiInsights.e5ce6aa6.svg";